import { Box, Button, Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Repeat } from "lib/@components/repeat"
import { If, Else } from "lib/@components/switch"
import { confirm } from "lib/@dialogs/confirm"
import { invalidate } from "lib/graphql/cache"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { getFentraLog } from "routes/qa/fentra/controllers/get-fentra-log"
import { clearFentraLog } from "routes/qa/fentra/controllers/fentra-mutations"
import { FentraLogRow } from "routes/qa/fentra/log/fentra-log-row"

export function FentraLogTab() {
    const { target } = useBoundContext()
    const { _id: profileId } = target ?? {}
    // Limit to 100 most recent entries — the server returns them newest-first
    const entries = getFentraLog.useResults({ profileId, limit: 100 }) ?? []

    return (
        <Box sx={{ p: 3 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                <Typography variant="h6">Activity Log</Typography>
                <Button variant="outlined" color="warning" onClick={handleClearLog} disabled={entries.length === 0}>
                    Clear Log
                </Button>
            </Stack>

            <If value={entries.length > 0}>
                <Paper variant="outlined" sx={{ overflow: "hidden" }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ width: 140 }}>When</TableCell>
                                <TableCell sx={{ width: 80 }}>Method</TableCell>
                                <TableCell>Path</TableCell>
                                <TableCell sx={{ width: 80 }} align="center">
                                    Status
                                </TableCell>
                                <TableCell sx={{ width: 80 }} align="right">
                                    Duration
                                </TableCell>
                                <TableCell>Detail</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <Repeat list={entries} item={<FentraLogRow />} keyFn={entryKeyFn} pass="entry" />
                        </TableBody>
                    </Table>
                </Paper>
                <Else>
                    <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
                        No log entries yet.
                    </Typography>
                </Else>
            </If>
        </Box>
    )

    function entryKeyFn(e) {
        return e._id
    }

    async function handleClearLog() {
        if (!(await confirm("Clear all log entries for this profile?", "Clear Log"))) return
        try {
            await clearFentraLog({ profileId })
            invalidate("fentraLog")
            successSnackbar("Log cleared")
        } catch (err) {
            errorSnackbar(err?.message || "Failed to clear log")
        }
    }
}
